import React from 'react';
import PropTypes from 'prop-types';
import { Table } from '@agconnections/grow-ui';
import FormattedNumber from 'components/FormattedNumber';
import { getProductTotalMath } from 'screens/Plans/components/PlanView/helpers';
import useUomConvert from 'hooks/useUomConvert';

const ProductsTable = ({
  products,
  displayFinancials
  // handleProductModal
}) => {
  const convertFn = useUomConvert();
  const handleSort = () => {};
  const sort = {};
  return (
    <>
      <Table>
        <Table.Header>
          <Table.Cell sort={sort} onClick={handleSort}>
            {`Products (${products.length})`}
          </Table.Cell>
          <Table.Cell sort={sort} onClick={handleSort}>
            Rate/Area
          </Table.Cell>
          <Table.Cell sort={sort} onClick={handleSort}>
            Applied Area
          </Table.Cell>
          <Table.Cell sort={sort} onClick={handleSort}>
            Applied Area %
          </Table.Cell>
          <Table.Cell sort={sort} onClick={handleSort}>
            Total Product
          </Table.Cell>
          <Table.Cell sort={sort} onClick={handleSort}>
            Total Cost
          </Table.Cell>
        </Table.Header>
        {products.map(product => {
          return (
            <Table.Row>
              <Table.Cell>
                <div className="text-left">
                  <div className="font-bold">
                    {product?.productName || 'No Products Selected'}
                  </div>
                  <div className="mt-2 text-neutral-300">
                    {product?.manufacturerName || '--'}
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                {product?.productRateValue} {product?.productRateUnit}
              </Table.Cell>
              <Table.Cell>
                {product?.areaValue || '0'}
                {' ac'}
                {/* {product?.areaValue || '0 '} {`${product?.areaUnit}s`} */}
              </Table.Cell>
              <Table.Cell>{product?.coveragePercent * 100}%</Table.Cell>
              <Table.Cell>
                {getProductTotalMath(
                  product?.productRateValue,
                  product?.areaValue,
                  product,
                  convertFn
                )}{' '}
                {product?.totalProductUnit
                  ? `${product?.totalProductUnit}s`
                  : ''}
              </Table.Cell>
              <Table.Cell>
                {displayFinancials && product?.totalProductCost ? (
                  <FormattedNumber unit="usCurrency" roundedTo="2">
                    {product?.totalProductCost}
                  </FormattedNumber>
                ) : (
                  ''
                )}
                {/* <div
                  data-testid="product-table-view-button"
                  className="mr-8 absolute right-0 flex-none w-10"
                >
                  <Button
                    type="link-default"
                    onClick={() => {
                      handleProductModal(product);
                    }}
                  >
                    View
                  </Button>
                </div> */}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table>
    </>
  );
};

ProductsTable.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  displayFinancials: PropTypes.bool.isRequired
};

export default ProductsTable;
